import { useCallback, useMemo } from 'react';

export const useSearchParams = () => {
  const history = window.history;

  const insertUrlParam = useCallback(
    (key: string, value: string | number) => {
      let searchParams = new URLSearchParams(window.location.search);
      searchParams.set(key, `${value}`);
      let newurl =
        window.location.protocol +
        '//' +
        window.location.host +
        window.location.pathname +
        '?' +
        searchParams.toString();
      history.pushState({ path: newurl }, '', newurl);
    },
    [history],
  );

  // to remove the specific key
  const removeUrlParameter = useCallback(
    (paramKey: string) => {
      const url = window.location.href;
      var r = new URL(url);
      r.searchParams.delete(paramKey);
      const newUrl = r.href;
      history.pushState({ path: newUrl }, '', newUrl);
    },
    [history],
  );

  const getUrlParam = useCallback((key: string) => {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.get(key) || null; // Trả về null nếu không có
  }, []);

  return useMemo(
    () => ({
      insertUrlParam,
      removeUrlParameter,
      getUrlParam,
    }),
    [insertUrlParam, removeUrlParameter, getUrlParam],
  );
};
